import React, {useEffect} from 'react'
import {Link} from "react-router-dom"

const Privacy = (props) => {

  useEffect(() => {
    window.scrollTo(0,0)
  },[])

  return ( <>
  <div style={{ position: 'relative' }}>

    <audio controls src={`${process.env.PUBLIC_URL}/songs/Lake Pleasant Remembers - OurStorySong.mp3`}></audio>
    <br/>
    <a href={`${process.env.PUBLIC_URL}/Lake Pleasant Remembers - OurStorySong.mp3`} download>Download</a>

    <h2>Lake Pleasant Remembers</h2>

    <p>
        [Verse 1]<br/>
        The first time I came here, the fire was warm<br/>
        Scotch on the rocks, October storms<br/>
        Didn’t know what I’d find, but the air was clear<br/>
        And I found forever waiting here<br/>
        <br/>
        [Verse 2]<br/> 
        Newlyweds walking the shoreline sand<br/>
        Canoes drifting steady, hand in hand<br/>
        Summers of laughter, winters of cold<br/>
        A cabin of stories, a love to hold<br/>
        <br/>
        [Chorus]<br/> 
        And the water remembers, the pines still stand tall<br/>
        Through seasons of sorrow, through joy, through it all<br/>
        Though time takes its toll, and shadows may fall<br/>
        Lake Pleasant remembers, and so do we all<br/>
        <br/>
        [Verse 3]<br/>
        Two little boys, barefoot and free<br/>
        Swam out too far, but swam back to me<br/>
        The years move along, but the shoreline stays<br/>
        Holding our footsteps, keeping our days<br/>
        <br/>
        [Bridge]<br/> 
        Grant’s laughter echoes, Todd’s smile in the waves<br/>
        Their spirits still linger in the sunlight haze<br/>
        And every July, when the family’s near<br/>
        I feel them beside me, I know they are here<br/>
        <br/>
        [Chorus]<br/> 
        And the water remembers, the pines still stand tall<br/>
        Through seasons of sorrow, through joy, through it all<br/>
        Though time takes its toll, and shadows may fall<br/>
        Lake Pleasant remembers, and so do we all<br/>
        <br/>
        [Outro]<br/> 
        So I’ll keep returning, as long as I can<br/>
        The lake holds my heart, the years in its hands<br/>
        With Tim and his children, new laughter will call<br/>
        Lake Pleasant remembers, and so do we all<br/>
    </p>

    <img
    src={`${process.env.PUBLIC_URL}/songs/Lake Pleasant.jpg`}
    alt="Lake Pleasant Sunset"
    style={{
    width: '100%',
    }}
    />

    </div>
  </> )
}

export default Privacy
